<template>
  <Icon>
    <svg slot="svg" width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M9.85714286,3 C8.67968714,3 7.71428571,3.98767992 7.71428571,5.19230769 L7.71428571,5.92307692 L4.14285714,5.92307692 C2.96540143,5.92307692 2,6.91075685 2,8.11538462 L2,19.8076923 C2,21.0123201 2.96540143,22 4.14285714,22 L19.8571429,22 C21.0345986,22 22,21.0123201 22,19.8076923 L22,8.11538462 C22,6.91075685 21.0345986,5.92307692 19.8571429,5.92307692 L16.2857143,5.92307692 L16.2857143,5.19230769 C16.2857143,3.98767992 15.3203129,3 14.1428571,3 L9.85714286,3 Z M9.85714286,4.46153846 L14.1428571,4.46153846 C14.5446429,4.46153846 14.8571429,4.78125 14.8571429,5.19230769 L14.8571429,5.92307692 L9.14285714,5.92307692 L9.14285714,5.19230769 C9.14285714,4.78125 9.45535714,4.46153846 9.85714286,4.46153846 Z M4.14285714,7.38461538 L19.8571429,7.38461538 C20.2589286,7.38461538 20.5714286,7.70432692 20.5714286,8.11538462 L20.5714286,13.2307692 L17.7142857,13.2307692 L17.7142857,11.7692308 L14.8571429,11.7692308 L14.8571429,13.2307692 L9.14285714,13.2307692 L9.14285714,11.7692308 L6.28571429,11.7692308 L6.28571429,13.2307692 L3.42857143,13.2307692 L3.42857143,8.11538462 C3.42857143,7.70432692 3.74107143,7.38461538 4.14285714,7.38461538 Z M3.42857143,14.6923077 L20.5714286,14.6923077 L20.5714286,19.8076923 C20.5714286,20.21875 20.2589286,20.5384615 19.8571429,20.5384615 L4.14285714,20.5384615 C3.74107143,20.5384615 3.42857143,20.21875 3.42857143,19.8076923 L3.42857143,14.6923077 Z" id="path-1-company"></path>
      </defs>
      <g id="blocks/topnav" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1319.000000, -32.000000)">
        <g id="Topnav">
          <g id="Stacked-Group-6" transform="translate(1317.000000, 29.000000)">
            <g id="icons/company">
              <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
              <mask id="mask-2-company" fill="white">
                <use xlink:href="#path-1-company"></use>
              </mask>
              <use id="Shape" fill="#43CEA2" fill-rule="nonzero" xlink:href="#path-1-company"></use>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsCompanyIcon",
  components: {
    Icon
  }
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-company-icon.vue